import React, { useEffect, useState } from 'react'
import ol from "openlayers";
import "ol/ol.css";
import stylelocal from "./BanDo.module.css"
import { SelectHuyenMulti } from '../../shared/selecthuyenmulti/SelectHuyenMulti';
import Autocomplete from 'react-autocomplete';
import TimKiemApi from '../../api/TimKiemApi';
import { SidebarLayer } from '../../shared/sidebar-layer/SidebarLayer';
import { FooterNote } from '../../shared/footer-note/FooterNote';
import BanDoPublicApi from '../../api/BanDoPublicApi';
import jsPDF from 'jspdf';
import * as htmlToImage from 'html-to-image';
import { SidebarLeft } from '../../shared/sidebar-left/SidebarLeft';
import { TimKiemNangCao } from '../../shared/timkiemnangcao/TimKiemNangCao';
import ThongBao from '../../core/ThongBao';
import { ModalChatLuong } from '../../shared/modaladdedit/ModalChatLuong';
import { ModalHienTrang } from '../../shared/modaladdedit/ModalHienTrang';
import { ModalThichHop } from '../../shared/modaladdedit/ModalThichHop';
import { ModalThoNhuong } from '../../shared/modaladdedit/ModalThoNhuong';
import { ModalDeXuat } from '../../shared/modaladdedit/ModalDeXuat';
import { Loading } from '../../shared/loading/Loading';
import { ModalNongHoa } from '../../shared/modaladdedit/ModalNongHoa';
import Authen from '../../core/Authen';

export const BanDo = () => {
    const view = new ol.View({
        center: [12031226.4706, 1518077.6003],
        zoom: 10.2
    });
    var [isEdit, setIsEdit] = useState(false);
    var [showModalAddEdit, setShowModalAddEdit] = useState('');
    var [thongTinAddEdit, setThongTinAddEdit] = useState({});
    const [addEdit, setAddEdit] = useState(0);
    var [isThongTin, setIsThongTin] = useState(true);
    var [map, setMap] = useState(new ol.Map());
    var [showLeft, setShowLeft] = useState(0);
    const [selectGhiChu, setSelectGhiChu] = useState({});
    const [listFilters, setListFilter] = useState([]);
    const [valueFilter, setValueFilter] = useState('');
    var requestTimer = null;
    const [listHuyens, setListHuyen] = useState([]);
    var [showRight, setShowRight] = useState(0);
    var [thongTin, setThongTin] = useState({});
    var [listLopBanDos, setLopBanDo] = useState([]);
    var [tabSelect, setTabSelect] = useState('');
    var [x, setX] = useState(0);
    var [y, setY] = useState(0);
    var [id, setId] = useState(null);
    var [listMenu, setListMenu] = useState([]);
    var [showTimKiemNangCao, setShowTimKiemNangCao] = useState(0);
    const [loading, setLoading] = useState(false);

    var [soureAdd, setSoureAdd] = useState(new ol.source.Vector(
        { wrapX: false }
    ));
    var [vectorAdd, setVectorAdd] = useState(new ol.layer.Vector({
        source: soureAdd,
        zIndex: 999
    }));
    var [drawAdd, setdrawAdd] = useState(new ol.interaction.Draw({
        source: soureAdd,
        type: "Polygon"
    }));

    var [mousePositionControl, setMousePositionControl] = useState()
    var [drawDo, setDrawDo] = useState(null);
    var [soureDo, setSoureDo] = useState(new ol.source.Vector());
    var [vectorDo, setVectorDo] = useState(new ol.layer.Vector());
    var [vectorSelect, setVectorSelect] = useState(new ol.layer.Vector());
    var [positionFeature, setPositionFeature] = useState(new ol.Feature());
    var [accuracyFeature, setAccuracyFeature] = useState(new ol.Feature());
    var [sourceBase, setSourceBase] = useState(new ol.source.OSM({
        attributions: ['Phần mềm quản lý sử dụng đất sản xuất nông nghiệp Hà Nội'],
        url: 'http://mt0.google.com/vt/lyrs=s&hl=vn&x={x}&y={y}&z={z}',
    }));
    var [mapBase, setMapBase] = useState(new ol.layer.Tile({
        source: sourceBase
    }));
    var [bingMap, setBingMap] = useState(new ol.layer.Tile({
        preload: Infinity,
        zIndex: 1,
        source: new ol.source.BingMaps({
            key: 'Avt2mvsr-HdT809JeTWasadqQrzmbWjSKja8sX14syV5YXV6xywEfc_Ub6cvJLN0',
            imagerySet: 'Aerial'
        })
    }));
    var [geolocaltion, setGeoLocaltion] = useState(new ol.Geolocation({
        trackingOptions: {
            enableHighAccuracy: true,
        },
        projection: view.getProjection()
    }));


    const [roleAdd, setRoleAdd] = useState(false);
    const [roleEdit, setRoleEdit] = useState(false);
    const [roleDel, setRoleDel] = useState(false);


    const onPrint = () => {
        let view = map.getViewport();
        htmlToImage.toPng(view).then(function (dataUrl) {
            var pdf = new jsPDF('landscape');
            // // var pdf = new jsPDF();
            pdf.addImage(dataUrl, 'PNG', 0, 0, view.clientWidth / 3.8, view.clientHeight / 3.8);
            // pdf.save("bando.pdf");
            // pdf.autoPrint();
            window.open(pdf.output('bloburl'), '_blank')
        });
    }

    const getIdHuyen = (listHuyens) => {
        setListHuyen(listHuyens)
        if (listLopBanDos.length > 0) {
            let params = {
                CQL_FILTER: listHuyens.length > 0 ? `maxa IN (${listHuyens.map(x => x.Ma).join(',')})` : 'maxa=100'
            }
            listLopBanDos.forEach(item => {
                if (item.province.getSource()) {
                    item.province.getSource().updateParams(params);
                }
            })
            setMap(map);
        }
    }

    const getSelectGhiChu = (e) => {
        let controll = document.getElementById('map');
        setSelectGhiChu(e);
        controll.setAttribute('edit-l', e.Ma);
    }

    const timkiemGhiChu = (e) => {
        listLopBanDos.forEach(item => {
            if (item.Ma == selectGhiChu.Ma && item.province.getSource()) {
                let params = {
                    // CQL_FILTER: listHuyens.length > 0 ? `maHuyen IN (${listHuyens.map(x => x.Ma).join(',')}) AND ${selectGhiChu.TimKiemGhiChu} IN (${e})` : 'maHuyen=100'
                    CQL_FILTER: e.Sql
                }
                item.province.getSource().updateParams(params);
            }
        });
        setMap(map);
    }

    const loadThongTin = async (x, y) => {
        try {
            const controll = document.getElementById('map');
            const maEdit = controll.getAttribute('edit-l');
            if (controll.getAttribute('addedit') === "0") {
                showRight++;
                setShowRight(showRight);
                let tableName = listMenu.filter(x => x.Checked && x.ParentId !== 'BANDONEN' && x.ParentId !== 'BANDOVETINH' && x.ParentId !== 'BDHANHCHINH' && x.LayerName != null);
                if (tableName.length === 0) {
                    tableName = listMenu.filter(x => x.Ma === 'BDHANHCHINHHUYEN');
                    if (tableName.length === 0) {
                        return;
                    }
                    tabSelect = tableName[0].Ma;
                    setTabSelect(tabSelect);
                }
                else {
                    if (tabSelect === '') {
                        tabSelect = tableName[0].Ma;
                        setTabSelect(tabSelect);
                    }
                    else {
                        const index = tableName.findIndex(x => x.Ma == tabSelect);
                        if (index === -1) {
                            tabSelect = tableName[0].Ma;
                            setTabSelect(tabSelect);
                        }
                        else{
                            setTabSelect(tabSelect);
                        }
                    }
                }
            }
            else {
                tabSelect = maEdit;
                setTabSelect(tabSelect);
            }

            const params = {
                x: x,
                y: y,
                tableName: tabSelect
            }
            setLoading(true);
            thongTin = await BanDoPublicApi.getDetail(params);
            thongTin.Ma = tabSelect;
            setThongTin(thongTin);
            setX(x);
            setY(y);
            setLoading(false);
            if (thongTin.geomjson != null) {
                map.getLayers().forEach(item => {
                    if (item != null && item.type === 'VECTOR') {
                        map.removeLayer(item);
                    }
                });
                const feature = new ol.format.GeoJSON().readFeatures(thongTin.geomjson);
                feature.forEach(item => {
                    item.setId(thongTin.id);
                })
                vectorSelect = new ol.layer.Vector({
                    source: new ol.source.Vector({
                        features: feature,
                    }),
                    style: highlightStyle,
                    zIndex: 999
                });
                map.addLayer(vectorSelect);
            }
            else {
                map.getLayers().forEach(item => {
                    if (item == vectorSelect) {
                        map.removeLayer(vectorSelect);
                    }
                });
            }
        }
        catch {
            setLoading(false);
        }
    }

    const loadThongTinById = async (e) => {
        try {
            const index = listMenu.findIndex(x => x.TableName === e.tableName);
            if (index !== -1) {
                tabSelect = listMenu[index].Ma;
                setTabSelect(tabSelect);
            }
            setLoading(true);
            showRight++;
            setShowRight(showRight);
            thongTin = await BanDoPublicApi.getInfoById(e);
            setThongTin(thongTin);
            setId(e.id);
            if (thongTin.geomjson != null) {
                map.getLayers().forEach(item => {
                    if (item != null && item.type === 'VECTOR') {
                        map.removeLayer(item);
                    }
                });
                const features = new ol.format.GeoJSON().readFeatures(thongTin.geomjson);
                vectorSelect = new ol.layer.Vector({
                    source: new ol.source.Vector({
                        features: features,
                    }),
                    style: highlightStyle,
                    zIndex: 999
                });
                setVectorSelect(vectorSelect);
                map.addLayer(vectorSelect);
                const toaDo = new ol.extent.getCenter(features[0].getGeometry().getExtent());
                flyTo(toaDo, 14);
            }
            else {
                map.getLayers().forEach(item => {
                    if (item == vectorSelect) {
                        map.removeLayer(vectorSelect);
                    }
                });
            }
            setLoading(false);
        }
        catch {
            setLoading(false);
        }

    }

    useEffect(() => {
        setRoleAdd(Authen.checkQuyen('BANDO_CREATE'));
        setRoleEdit(Authen.checkQuyen('BANDO_UPDATE'));
        setRoleDel(Authen.checkQuyen('BANDO_DELETE'));
    }, []);

    useEffect(() => {
        vectorDo = new ol.layer.Vector({
            source: soureDo,
            style: new ol.style.Style({
                fill: ol.style.Fill({
                    color: 'rgba(255, 255, 255, 0.2)',
                }),
                stroke: new ol.style.Stroke({
                    color: '#ffcc33',
                    width: 2,
                }),
                image: new ol.style.Circle({
                    radius: 7,
                    fill: new ol.style.Fill({
                        color: '#ffcc33',
                    }),
                })
            }),
            zIndex: 200
        });
        positionFeature.setStyle(
            new ol.style.Style({
                image: new ol.style.Circle({
                    radius: 6,
                    fill: new ol.style.Fill({
                        color: '#3399CC',
                    }),
                    stroke: new ol.style.Stroke({
                        color: '#fff',
                        width: 2,
                    }),
                }),
            })
        );
        geolocaltion.on('change:accuracyGeometry', function () {
            accuracyFeature.setGeometry(geolocaltion.getAccuracyGeometry());
        });
        geolocaltion.on('change:position', function () {
            let coordinates = geolocaltion.getPosition();
            positionFeature.setGeometry(coordinates ? new ol.geom.Point(coordinates) : null);
            if (coordinates) {
                map.setView(new ol.View({
                    center: coordinates,
                    zoom: 14
                }))
            }
        });
        mousePositionControl = new ol.control.MousePosition({
            coordinateFormat: ol.coordinate.createStringXY(4),
            projection: 'EPSG:4326',
            className: 'custom-mouse-position',
            target: document.getElementById('mouse-position'),
            undefinedHTML: ''
        });
        setMousePositionControl(mousePositionControl);
        var projectionSelect = document.getElementById('projection');
        projectionSelect.addEventListener('change', function (event) {
            mousePositionControl.setProjection(event.target.value);
        });
        map = new ol.Map({
            target: "map",
            controls: new ol.control.defaults().extend([
                new ol.control.ScaleLine({
                    units: 'metric'
                }),
                new ol.control.FullScreen(),
                new ol.control.ZoomSlider(),
                mousePositionControl
            ]),
            layers: [
                mapBase
                // bingMap
            ],
            view: view
        });
        let vectorViTri = new ol.layer.Vector({
            map: map,
            source: new ol.source.Vector({
                features: [accuracyFeature, positionFeature]
            })
        });
        map.addLayer(vectorViTri);
        map.addControl(customControl('id-do-khoang-cach', stylelocal.dokhoangcach, '<i class="fas fa-ruler-horizontal"></i>', clickDoKhoangCach));
        map.addControl(customControl('id-do-dien-tich', stylelocal.dodientich, '<i class="fas fa-draw-polygon"></i>', clickDoDienTich));
        map.addControl(customControl('id-do-vi-tri', stylelocal.vitri, '<i class="fas fa-map-marker-alt"></i>', clickViTri));
        map.addControl(customControl('id-tk-nang-cao', stylelocal.tknangcao, '<i class="fas fa-search"></i>', timKiemNangCao));
        map.addControl(customControl('id-lop-ban-do', stylelocal.lopbando, '<i class="fas fa-layer-group"></i>', showLopBanDo));
        setVectorDo(vectorDo);
        setPositionFeature(positionFeature);
        map.on('click', function (evt) {
            const controllAddEdit = document.getElementById('map').getAttribute('addedit');
            const controllIsEdit = document.getElementById('map').getAttribute('isedit');
            if (isThongTin === false || controllAddEdit === "1" || controllIsEdit === "1") {
                return;
            }
            loadThongTin(evt.coordinate[0], evt.coordinate[1]);
        });
        setMap(map);
    }, []);

    const showLopBanDo = () => {
        showLeft++;
        setShowLeft(showLeft);
    }

    const updateTableSelect = (e) => {
        tabSelect = e;
        setTabSelect(tabSelect);
        loadThongTin(x, y);
    }

    const highlightStyle = new ol.style.Style({
        // fill: new ol.style.Fill({
        //     color: 'red',
        // }),
        image: new ol.style.Circle({
            radius: 7,
            fill: new ol.style.Fill({
                color: '#ffcc33'
            })
        }),
        stroke: new ol.style.Stroke({
            color: 'blue',
            width: 2,
        }),
    });

    const removeAttribute = (id) => {
        let controll = document.getElementById(id);
        if (controll.hasAttribute('active')) {
            controll.removeAttribute('active');
            controll.removeAttribute('class');
            map.removeInteraction(drawDo);
            vectorDo.getSource().clear();
            map.removeLayer(vectorDo);
            map.getOverlays().clear();
        }
    }

    const clickDoKhoangCach = () => {
        let controllButton = document.getElementById('id-do-khoang-cach');
        removeAttribute('id-do-dien-tich');
        if (controllButton.hasAttribute('active')) {
            removeAttribute('id-do-khoang-cach');
            isThongTin = true;
        }
        else {
            isThongTin = false;
            controllButton.setAttribute('active', 1);
            controllButton.setAttribute('class', 'ctrl-active');
            map.addLayer(vectorDo);
            addInteractionDo('LineString');
        }
        setIsThongTin(isThongTin);
    }

    const clickDoDienTich = () => {
        let controllButton = document.getElementById('id-do-dien-tich');
        removeAttribute('id-do-khoang-cach');
        if (controllButton.hasAttribute('active')) {
            removeAttribute('id-do-dien-tich');
            isThongTin = true;
        }
        else {
            isThongTin = false;
            controllButton.setAttribute('active', 1);
            controllButton.setAttribute('class', 'ctrl-active');
            map.addLayer(vectorDo);
            addInteractionDo('Polygon');
        }
        setIsThongTin(isThongTin);
    }

    const clickViTri = () => {
        geolocaltion.setTracking(false);
        geolocaltion.setTracking(true);
    }

    function customControl(id, classCss, icon, func) {
        let button = document.createElement('button');
        button.setAttribute('id', id);
        button.innerHTML = icon;
        let element = document.createElement('div');
        element.className = classCss + ' ol-unselectable ol-control';
        element.appendChild(button);
        button.addEventListener('click', function () {
            func();
        }, false);
        return new ol.control.Control({
            element: element
        });
    }


    function flyTo(localtion, zoomNew) {
        let duration = 2000;
        let parts = 2;
        let called = false;
        function callback(complete) {
            --parts;
            if (called) {
                return;
            }
            if (parts === 0 || !complete) {
                called = true;
            }
        }
        map.getView().animate(
            {
                center: localtion,
                duration: duration
            },
            callback
        );
        map.getView().animate(
            {
                zoom: zoomNew - 1,
                duration: duration / 2
            },
            {
                zoom: zoomNew,
                duration: duration / 2
            },
            callback
        )
    }

    var sketch;
    var helpTooltipElement;
    var helpTooltip;

    const createHelpTooltip = () => {
        if (helpTooltipElement) {
            helpTooltipElement.parentNode.removeChild(helpTooltipElement);
        }
        helpTooltipElement = document.createElement('div');
        helpTooltipElement.className = 'ol-tooltip hidden';
        helpTooltip = new ol.Overlay({
            element: helpTooltipElement,
            offset: [15, 0],
            positioning: 'center-left',
        });
        map.addOverlay(helpTooltip);
        setMap(map);
    }
    var sketch;
    var measureTooltipElement;
    var measureTooltip;
    const addInteractionDo = (type) => {
        drawDo = new ol.interaction.Draw({
            source: soureDo,
            type: type,
            style: new ol.style.Style({
                fill: new ol.style.Fill({
                    color: 'rgba(255, 255, 255, 0.2)',
                }),
                stroke: new ol.style.Stroke({
                    color: 'rgba(0, 0, 0, 0.5)',
                    lineDash: [10, 10],
                    width: 2,
                }),
                image: new ol.style.Circle({
                    radius: 5,
                    stroke: new ol.style.Stroke({
                        color: 'rgba(0, 0, 0, 0.7)',
                    }),
                    fill: new ol.style.Fill({
                        color: 'rgba(255, 255, 255, 0.2)'
                    })
                })
            })
        });
        map.addInteraction(drawDo);
        setDrawDo(drawDo);
        createMeasureTooltip();
        createHelpTooltip();
        var listener;
        drawDo.on('drawstart', function (evt) {
            sketch = evt.feature;
            var tooltipCoord = evt.coordinate;
            listener = sketch.getGeometry().on('change', function (evt) {
                var geom = evt.target;
                var output;
                if (geom instanceof ol.geom.Polygon) {
                    output = formatArea(geom);
                    tooltipCoord = geom.getInteriorPoint().getCoordinates();
                } else if (geom instanceof ol.geom.LineString) {
                    output = formatLength(geom);
                    tooltipCoord = geom.getLastCoordinate();
                }
                measureTooltipElement.innerHTML = output;
                measureTooltip.setPosition(tooltipCoord);
            })
        });
        drawDo.on('drawend', function () {
            measureTooltipElement.className = 'ol-tooltip ol-tooltip-static';
            measureTooltip.setOffset([0, -7]);
            // unset sketch
            sketch = null;
            // unset tooltip so that a new one can be created
            measureTooltipElement = null;
            createMeasureTooltip();
            ol.Observable.unByKey(listener);
        });
        setDrawDo(drawDo);
        setMap(map);
    }

    const formatArea = (polygon) => {
        var area = ol.Sphere.getArea(polygon);
        var output;
        if (area > 10000) {
            output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km<sup>2</sup>';
        } else {
            output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>';
        }
        return output;
    };

    const formatLength = (line) => {
        var length = ol.Sphere.getLength(line);
        var output;
        if (length > 100) {
            output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
        } else {
            output = Math.round(length * 100) / 100 + ' ' + 'm';
        }
        return output;
    };

    function createMeasureTooltip() {
        if (measureTooltipElement) {
            measureTooltipElement.parentNode.removeChild(measureTooltipElement);
        }
        measureTooltipElement = document.createElement('div');
        measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
        measureTooltip = new ol.Overlay({
            element: measureTooltipElement,
            offset: [0, -15],
            positioning: 'bottom-center',
        });
        map.addOverlay(measureTooltip);
    }

    const timKiemNangCao = () => {
        showTimKiemNangCao++;
        setShowTimKiemNangCao(showTimKiemNangCao);
    }

    //thay đổi lựa chọn bản đồ từ menu
    const selectBanDo = async (listMenus) => {
        // console.log(listMenus);
        listMenus.forEach(item => {
            const index = listMenu.findIndex(x => x.Ma === item.Ma);
            if (index === -1) {
                listMenu.push(item);
            }
            else {
                listMenu[index].Checked = item.Checked;
            }
        });
        listMenus.forEach(item => {
            if (item.ParentId === 'BANDOVETINH') {
                if (item.Ma === 'BING') {
                    let isCheck = true;
                    map.getLayers().forEach(l => {
                        if (l === bingMap) {
                            isCheck = false;
                        }
                    });
                    if (isCheck) {
                        bingMap.setVisible(true);
                        map.addLayer(bingMap);
                    }
                    else {
                        bingMap.setVisible(item.Checked);
                    }
                    mapBase.setVisible(false);
                }
                else {
                    if (sourceBase.getUrls().findIndex(x => x === item.Url) !== -1) {
                        mapBase.setVisible(item.Checked);
                    }
                    else if (item.Checked) {
                        sourceBase.setUrl(item.Url);
                        mapBase.setVisible(item.Checked);
                    }
                    bingMap.setVisible(false);
                    setSourceBase(sourceBase);
                    setMapBase(mapBase);
                }
            }
            if (item.ParentId !== 'BANDOVETINH' && item.Url != null) {
                const index = listLopBanDos.findIndex(x => x.Ma === item.Ma);
                if (index === -1) {
                    let province = new ol.layer.Image({
                        source: new ol.source.ImageWMS({
                            url: item.Url,
                            params: { layers: item.LayerName, version: item.Version, CQL_FILTER: 'maxa IN (' + listHuyens.map(x => x.Ma).join(',') + ')' },
                            serverType: "geoserver",
                            ratio: item.Ratio,
                            crossOrigin: ''
                        }),
                        zIndex: item.SortOrder
                    });
                    province.setVisible(item.Checked);
                    province.setZIndex(item.SortOrder);
                    map.addLayer(province);
                    item.province = province;
                    listLopBanDos.push(item);
                }
                else {
                    listLopBanDos[index].province.setVisible(item.Checked);
                }
            }
        });
        setLopBanDo([...listLopBanDos]);
        setMap(map);
    }

    const onTimKiemNangCao = (e) => {
        listLopBanDos.forEach(item => {
            if (item.Ma === e.Ma && item.province.getSource()) {
                let params = {
                    CQL_FILTER: listHuyens.length > 0 ? `maxa IN (${listHuyens.map(x => x.Ma).join(',')}) AND ${e.Sql}` : 'maxa=100'
                }
                item.province.getSource().updateParams(params);
            }
        })
        setMap(map);
    }

    // Thêm bản đồ
    const addMap = () => {
        if (!selectGhiChu.Ma) {
            ThongBao.prinWarningMessage("Bạn chưa chọn lớp bản đồ.");
            showLeft++;
            setShowLeft(showLeft);
            return;
        }
        setAddEdit(1);
        let controllAddEdit = document.getElementById('map');
        controllAddEdit.setAttribute('addedit', 1);
        drawAdd = new ol.interaction.Draw({
            source: soureAdd,
            type: selectGhiChu.GeoType
        });
        drawAdd.on('drawend', function (e) {
            ThongBao.printConfirmationDialog('Bạn có muốn thêm đối tượng vừa vẽ không?', () => {
                var ma = selectGhiChu.Ma;
                var geoJson = new ol.format.WKT();
                var geoText = geoJson.writeGeometry(e.feature.getGeometry());
                setThongTinAddEdit({
                    geoText: geoText
                });
                setShowModalAddEdit(ma);
            }, () => {
                vectorAdd.getSource().clear();
            });
        });
        map.addInteraction(drawAdd);
        map.addLayer(vectorAdd);
        setMap(map);
        setdrawAdd(drawAdd);
    }
    // Sửa bản đồ
    const editMap = () => {
        if (!selectGhiChu.Ma) {
            ThongBao.prinWarningMessage("Bạn chưa chọn lớp bản đồ.");
            showLeft++;
            setShowLeft(showLeft);
            return;
        }
        setAddEdit(2);
        let controllAddEdit = document.getElementById('map');
        controllAddEdit.setAttribute('addedit', 2);
        let selectEdit = new ol.interaction.Select({ wrapX: false, });
        let modify = new ol.interaction.Modify({ features: selectEdit.getFeatures(), });
        map.getInteractions().extend([selectEdit, modify]);
        var selected_features = selectEdit.getFeatures();
        selected_features.on('add', function (evt) {
            var feature = evt.element;
            feature.on('change', function (evt) {
                isEdit = true;
                setIsEdit(isEdit);
                let controllIsEdit = document.getElementById('map');
                controllIsEdit.setAttribute('isedit', 1);
            });
        });

        selected_features.on('remove', function (evt) {
            if (isEdit) {
                isEdit = false;
                setIsEdit(isEdit);
                var feature = evt.element;

                ThongBao.printConfirmationDialog("Bạn có muốn cập nhật sử thay đổi này không?", () => {
                    const geoJson = new ol.format.WKT();
                    const geoText = geoJson.writeGeometry(feature.getGeometry());
                    const id = feature.getId();
                    const controll = document.getElementById('map');
                    const maEdit = controll.getAttribute('edit-l');
                    showEditThongTin({
                        id: id,
                        geoText: geoText,
                        tableName: maEdit,
                    })
                }, () => {
                    // selectEdit.getSource().clear();
                });
                if (vectorSelect.getSource()) {
                    vectorSelect.getSource().clear();
                }
                let controllIsEdit = document.getElementById('map');
                controllIsEdit.setAttribute('isedit', 0);
            }

        });
        setMap(map);
    }

    // Hủy thêm sửa bản đồ
    const onCancelAddEdit = () => {
        if (addEdit === 1) {
            map.removeInteraction(drawAdd);
            map.removeLayer(vectorAdd);
        }
        else if (addEdit === 2) {
            vectorSelect.setStyle(highlightStyle);
            map.getInteractions().forEach(item => {
                map.removeInteraction(item);
            });
        }
        setAddEdit(0);
        setMap(map);
        let controllAddEdit = document.getElementById('map');
        controllAddEdit.setAttribute('addedit', 0);
    }

    const onDeleteMap = () => {
        ThongBao.printConfirmationDialog('Bạn có muốn xóa đối tượng được chọn trên bản đồ đi không?', () => {
            var tableName = selectGhiChu.TableName;
            let params = {
                id: thongTin.id,
                tableName: tableName
            }
            setLoading(true);
            BanDoPublicApi.delete(params).then((res) => {
                changeMapComplete();
                thongTin = {};
                setThongTin(thongTin);
                map.removeLayer(vectorSelect);
                setMap(map);
                setLoading(false);
            }, () => {
                setLoading(false);
            });
        })
    }

    const changeMapComplete = () => {
        // map.getView().animate(
        //     {
        //         center: [x, y]
        //     }
        // );
        listLopBanDos.forEach(item => {
            if (item.Ma === selectGhiChu.Ma) {
                item.province.changed();
            }
        })
    }

    const showEditThongTin = (e) => {
        let params = {
            id: e.id
        }
        setLoading(true);
        BanDoPublicApi.getById(params).then((res) => {
            res.geoText = e.geoText || '';
            setThongTinAddEdit(res);
            // setShowModalAddEdit(e.Ma);
            const ma = e.Ma == null ? selectGhiChu.Ma : e.Ma;
            setShowModalAddEdit(ma);
            setLoading(false);
        }, (errr) => {
            setLoading(false);
        });
    }

    const closeModalAddEdit = () => {
        if (addEdit === 1) {
            vectorAdd.getSource().clear();
        }
        setShowModalAddEdit('');
    }

    const onSapXep = (list) => {
        console.log(list);
        if (list.length > 0) {
            list.forEach(item => {
                const index = listLopBanDos.findIndex(x => x.Ma === item.Ma);
                if (index !== -1) {
                    listLopBanDos[index].province.setZIndex(item.SortOrder);
                }
            })
        }
    }

    const timKiemThon = (geomjson) =>{
        if (geomjson !== '') {
            const local = JSON.parse(geomjson);
            flyTo(local.coordinates, 15);
        }
    }

    return (
        <div className="card shadow mb-1">
            <div className="card-header py-2 row">
                <div className="col-md-4">
                    <SelectHuyenMulti onChangeHuyenProps={(e) => getIdHuyen(e)}></SelectHuyenMulti>
                </div>
                <div className="input-group col-md-4">
                    <Autocomplete
                        inputProps={{ id: 'states-autocomplete', className: 'form-control', placeholder: "Tên xã" }}
                        wrapperStyle={{ position: 'relative', display: 'inline-block', zIndex: 999, width: "100%" }}
                        value={valueFilter}
                        items={listFilters}
                        getItemValue={(item) => item.tenthon}
                        onSelect={(value, item) => {
                            timKiemThon(item.geomjson)
                            setValueFilter(value);
                        }}
                        onChange={(event, value) => {
                            setValueFilter(value);
                            clearTimeout(requestTimer)
                            
                            requestTimer = TimKiemApi.getFilter({ listHuyens: listHuyens.map(x => x.Ma).join(','), filter: value }).then((response) => {
                                setListFilter(response);
                            });
                        }}
                        renderItem={(item, isHighlighted) => (
                            <div
                                className={`item ${isHighlighted ? 'item-highlighted' : ''}`}
                                key={item.tenthon}
                            >{item.tenthon}</div>
                        )}
                    />
                    <div className="input-group-append">
                        <i class="fas fa-search tk-ban-do"></i>
                    </div>
                </div>
                <div className="col-md-4 bd-button text-right">
                    {/* {addEdit === 0 && roleAdd ? <button type="button" className="btn btn-success btn-sm" onClick={addMap} disabled={!selectGhiChu.IsEdit}><i className="fas fa-plus"></i></button> : ''}
                    {addEdit === 0 && roleEdit ? <button type="button" className="btn btn-primary btn-sm" onClick={editMap} disabled={!selectGhiChu.IsEdit}><i className="fas fa-edit"></i></button> : ''}
                    {addEdit !== 0 ? <button type="button" className="btn btn-warning btn-sm" onClick={onCancelAddEdit}><i className="fas fa-ban"></i> Hủy</button> : ''}
                    {addEdit === 0 && roleDel ? <button type="button" className="btn btn-danger btn-sm" onClick={onDeleteMap} disabled={!thongTin.id}><i className='fas fa-trash-alt'></i></button> : ''}
                    <button type="button" className="btn btn-info btn-sm" onClick={onPrint}><i className='fas fa-print'></i></button> */}
                </div>
            </div>
            <div className="card-body">
                <div className="col-md-12">
                    <div className="row bd-admin">
                        <SidebarLayer show={showRight} thongTin={thongTin} listLopBanDos={listLopBanDos} tabSelect={tabSelect} x={x} y={y} width="242" admin={true}
                            showEditThongTin={(e) => showEditThongTin(e)} updateTableSelect={(e) => updateTableSelect(e)}>
                        </SidebarLayer>
                        <div className={'col-md-12 ' + stylelocal.bando} id="map" addedit="0">
                        </div>
                        <FooterNote maBanDo={selectGhiChu.Ma} timKiemGhiChu={(e) => timkiemGhiChu(e)} height="140">
                        </FooterNote>
                        <TimKiemNangCao show={showTimKiemNangCao} listLopBanDos={listLopBanDos} onTimKiemNangCao={(e) => onTimKiemNangCao(e)} listHuyens={listHuyens}
                            loadThongTinById={(e) => loadThongTinById(e)}></TimKiemNangCao>
                        <SidebarLeft selectBanDo={selectBanDo} show={showLeft} getGhiChu={(e) => getSelectGhiChu(e)} onSapXep={(e) => onSapXep(e)}>
                        </SidebarLeft>
                    </div>
                    <div className="row footer-map">
                        <div className="col-md-2">
                            <select className="form-control" id="projection">
                                <option value="EPSG:4326">EPSG:4326</option>
                                <option value="EPSG:3857">EPSG:3857</option>
                            </select>
                        </div>
                        <div className="col-md-1 text-right">
                            <i class="fas fa-mouse-pointer"></i> Tọa độ:
                        </div>
                        <div className="col-md-4">
                            <div id="mouse-position"></div>
                        </div>
                    </div>
                </div>
            </div>
            <Loading loading={loading}></Loading>
            <ModalChatLuong showModal={showModalAddEdit === 'BDCHATLUONGDAT'} handleClose={closeModalAddEdit} thongTin={thongTinAddEdit} changeMapComplete={changeMapComplete}></ModalChatLuong>
            <ModalDeXuat showModal={showModalAddEdit === 'BDDEXUATSUDUNGDAT'} handleClose={closeModalAddEdit} thongTin={thongTinAddEdit} changeMapComplete={changeMapComplete}></ModalDeXuat>
            <ModalHienTrang showModal={showModalAddEdit === 'BDHIENTRANGSUDUNGDAT'} handleClose={closeModalAddEdit} thongTin={thongTinAddEdit} changeMapComplete={changeMapComplete}></ModalHienTrang>
            <ModalThichHop showModal={showModalAddEdit === 'BDTHICHHOPSUDUNGDAT'} handleClose={closeModalAddEdit} thongTin={thongTinAddEdit} changeMapComplete={changeMapComplete}></ModalThichHop>
            <ModalThoNhuong showModal={showModalAddEdit === 'BDTHONHUONG'} handleClose={closeModalAddEdit} thongTin={thongTinAddEdit} changeMapComplete={changeMapComplete}></ModalThoNhuong>
            <ModalNongHoa showModal={showModalAddEdit === 'BDNONGHOA'} handleClose={closeModalAddEdit} thongTin={thongTinAddEdit} changeMapComplete={changeMapComplete}></ModalNongHoa>
        </div>
    )
}